import {defineAsyncComponent} from 'vue'

export const GlobalComponents = {
    // Helpers
    'script-component-svg-icon': defineAsyncComponent(() => import('./SvgIconComponent.vue')),

}
